import React, { Component } from 'react';

class CoffeeTracker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queue:[],
      ready: 0,
      connection_lost: true,
      notify: (typeof Notification !== 'undefined') && Notification.permission
    }
    this.pollCoffees()
  }

  pollCoffees(){
    fetch('/api/order/coffees/queue/' + this.props.schoolId)
      .then(res => {
        if(res.ok)
          return res.json()
        else
          throw new Error('Network response was not ok.');
      })
      .then(x=>{
        x.connection_lost = false
        x.ready = x.queue.indexOf(this.props.orderId) < 0
        if(x.ready && !this.state.ready){
          clearInterval(this.pollInterval)
          this.showNotification()
        }
        this.setState(x);
      })
      .catch(error=> {
        console.log('error', error);
        this.setState({error: error.toString(), connection_lost: true})
      });
  }

  componentDidMount(){
    this.pollInterval = setInterval(this.pollCoffees.bind(this), 5000)
  }

  componentWillUnmount(){
    clearInterval(this.pollInterval)
  }

  showNotification(){
    if(this.state.notify === 'granted'){
      // return new Notification("Your coffee order is ready!");

      // ServiceWorkerRegistration.showNotification("Your coffee order is ready!");

      if(navigator.serviceWorker)
        navigator.serviceWorker.ready.then(worker=>
          worker.showNotification('My School Lunch',{
            body: 'Your coffee order is ready!',
            icon: '/favicon/android-icon-96x96.png'
          }))
      else
        try{
          if (typeof Notification !== 'undefined')
            new Notification("Your coffee order is ready!")
          else
            alert("Your coffee order is ready!")
        } catch(err){
          alert("Your coffee order is ready!")
        };
    } else {
      alert("Your coffee order is ready!")
    }
  }

  getPosition(){
    return this.state.queue.indexOf(this.props.orderId) + 1;
  }

  request(e){
    e.preventDefault();
    Notification.requestPermission((permission)=>{
      this.setState({notify: permission})
    })
  }

  render() {
    return (
      <div>
        { this.state.notify === 'default' ? (
          <div className="alert alert-success" role="alert">
            <div className="row">
              <div className="col-xs-8">
                Would you like a notification when your coffee is ready?
              </div>
              <div className="col-xs-4">
                <button
                  className="btn btn-block btn-success float-right"
                  onClick={this.request.bind(this)}>
                  Allow</button>
              </div>
            </div>
          </div>
        ) : null}

        <div className="panel panel-primary">
          <div className="panel-heading">
            <h3 className="panel-title">Coffee Tracker</h3>
          </div>
          <div className="panel-body">
            { this.state.connection_lost ? (
              <p>
                Connection to coffee tracker lost, coffee
                status unknown. Attempting to reconnect...
              </p>
            ) : (
              <div>
                <p>Coffee Ready: {this.state.ready ? 'Yes!' : 'Not yet'}</p>
                {this.state.ready ? null :
                <p>Position in queue: {this.getPosition()} of {this.state.queue.length}</p>}
              </div>
            ) }
          </div>
        </div>
      </div>
    );
  }
}

export default CoffeeTracker;



// WEBPACK FOOTER //
// ./src/pages/components/CoffeeTracker.js